import { URL_BASE_POLIZARIO, URL_BASE_POLIZARIO_QUALITAS, URL_GSEGUROS_DATOS } from "../../constants/url";
import {
  composeErrorNotification,
  
} from "../../utils/composeNotification";
import { get, post } from "../../utils/fetch";

import { types } from "../types/types";
import { notification } from "./notificationActions";


export const startGet6Digitos= (digitos) => {
  return async (dispatch) => {
    dispatch(setLoadingPolizario(true));

    const url = `${URL_BASE_POLIZARIO}/Elaguila/Get6Digitos/${digitos}`;

    const result = await get(url);


    if (result.code === 0) {
      dispatch(storeElAguilaLista(result.data));
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Get 6 Digitos",
            `${result.error}`
          )
        )
      );
    }
    dispatch(setVistaResultados(1));
    dispatch(setLoadingPolizario(false));
  };
};

export const startGetLista = (validador1) => {
  return async (dispatch) => {
    dispatch(setLoadingPolizario(true));

    const url = `${URL_BASE_POLIZARIO}/Elaguila/GetByPolizaExacta/${validador1}`;

    const result = await get(url);

    console.log("RESULT", result);

    if (result.code === 0) {
      dispatch(storeElAguilaLista(result.data));
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Get lista",
            `${result.error}`
          )
        )
      );
    }
    dispatch(setVistaResultados(1));
    dispatch(setLoadingPolizario(false));
  };
};

export const startGetDetalle = (elaguilaID) => {
  return async (dispatch) => {
    dispatch(setLoadingPolizario(true));
    const url = `${URL_BASE_POLIZARIO}/Elaguila/GetDetalle/${elaguilaID}`;

    const result = await get(url);

    if (result.code === 0) {
      dispatch(storeElAguilaPoliza(result.data));
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Get detalle",
            `${result.error}`
          )
        )
      );
    }
    dispatch(setVistaResultados(2));
    dispatch(setLoadingPolizario(false));
  };
};

const storeElAguilaLista = (lista) => ({
  type: types.storeElAguilaLista,
  payload: lista,
});

const storeElAguilaPoliza = (poliza) => ({
  type: types.storeElAguilaPoliza,
  payload: poliza,
});

export const setClienteID = (clienteID) => ({
  type: types.setClienteID,
  payload: clienteID,
});

export const setLoadingPolizario = (state) => ({
  type: types.setLoadingPolizario,
  payload: state,
});

export const setVistaResultados = (vista) => ({
  type: types.setVistaResultados,
  payload: vista,
});


/////// QUALITAS

export const startQueryQualitas = () => {
  return async (dispatch, getState) => {
    const { validador1 } = getState().asistenciasReducer.captura
    const validador = validador1.split("-")

    if(validador.length !== 2) return;

    dispatch(setLoadingPolizario(true));

    const fechaActual = new Date();
    const fechaFormateada = fechaActual.toISOString().split('T')[0];

    const body = {
      "poliza": validador[0],
      "inciso": validador[1],
      "fecha": fechaFormateada
    }

    const url = `${URL_BASE_POLIZARIO_QUALITAS}/api/query`
    const result = await post(url, body);
    dispatch(setLoadingPolizario(false));

    dispatch(setQualitasResponse(result.data))
  }
}

const setQualitasResponse = (payload) => ({
  type: types.setQualitasResponse,
  payload
})

/////// GSEGUROS

export const startQueryGSeguros = (datosForm) => {
  return async (dispatch) => {
    dispatch(setLoadingGSeguros(true));

    const body = {
      "sucursal": datosForm.sucursal,
      "ramo": datosForm.ramo,
      "poliza": datosForm.poliza,
      "inciso": datosForm.inciso
    }

    const result = await post(URL_GSEGUROS_DATOS, body);

    if (result.code === 0) {
      dispatch(setGSegurosResponse(result.data));
      dispatch(setGSegurosEmision(result.data.emision));
      dispatch(setVistaGSeguros(1));
    } else {
      dispatch(setGSegurosResponse(null));
      dispatch(setVistaGSeguros(0)); // 0 = mostrar travolta.png
    }

    dispatch(setLoadingGSeguros(false));
  }
}

export const startGetDetalleEmision = (emisionData) => {
  return async (dispatch) => {
    dispatch(setGSegurosEmision(emisionData));
    dispatch(setVistaGSeguros(2)); // 2 = mostrar detalle
  }
}

const setGSegurosResponse = (payload) => ({
  type: types.setGSegurosResponse,
  payload
})

const setGSegurosEmision = (payload) => ({
  type: types.setGSegurosEmision,
  payload
})

export const setLoadingGSeguros = (state) => ({
  type: types.setLoadingGSeguros,
  payload: state,
});

export const setVistaGSeguros = (vista) => ({
  type: types.setVistaGSeguros,
  payload: vista,
});

export const cleanGSegurosEmision = () => ({
  type: types.cleanGSegurosEmision,
  payload: null,
});

export const cleanPolizario = () => ({
  type: types.cleanPolizario,
  payload: null,
});